export class AdapterDetalleSelect {

    codigo: String;
    descripcion: String;


    constructor() { }



}



// WEBPACK FOOTER //
// ./src/app/models/adapter/adapter-detalle-select.ts